import { ICommonAPIErrorResponse } from '@/services/common/api';
import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

export enum ImpactLevels {
    Any = 'Any',
    Low = 'Low',
    Medium = 'Medium',
    High = 'High',
}

export interface IEconomicCalendarDto {
    actual: number;
    country: string;
    estimate: number | null;
    event: string;
    impact: ImpactLevels;
    time: string;
    prev: number;
    unit: string | null;
}

type CountryInfo = {
    label: string;
    icon: string;
};

countries.registerLocale(enLocale);

const aliasMap: Record<string, string> = {
    USA: 'United States',
    EuroZone: 'European Union',
    "Hong Kong": "Hong Kong SAR China",
};

export function enrichWithCountryInfo(
    data: IEconomicCalendarDto[]
): (IEconomicCalendarDto & CountryInfo)[] {
    return data.map((item) => {
        const originalName = item.country;
        const lookupName = aliasMap[originalName] || originalName;

        const code = countries.getAlpha2Code(lookupName, 'en');

        const countryInfo: CountryInfo = {
            label: originalName,
            icon: code?.toLowerCase() || 'unknown',
        };

        return {
            ...item,
            ...countryInfo,
        };
    });
}

export const economicCalendar = {
    getData: async (): Promise<(IEconomicCalendarDto & CountryInfo)[]> => {
        try {
            const res = await fetch('/api/economic-calendar');

            if (!res.ok) {
                console.error('[economicCalendar] Failed to load data:', res.statusText);
                return [];
            }

            const data = await res.json();

            console.log('[economicCalendar] Full response:', data);

            const economicCalendar = data.economicCalendar;

            if (!Array.isArray(economicCalendar)) {
                console.warn('[economicCalendar] Invalid format: expected an array');
                return [];
            }

            return enrichWithCountryInfo(economicCalendar);
        } catch (error) {
            console.error('[economicCalendar] Request failed:', error);
            return [];
        }
    },
};
